module.exports = __webpack_public_path__ + "static/image/company/m/image_vision_3@3x.jpg?b5c7639c";